module.exports = __webpack_public_path__ + "img/icon_add_person.de8cdec9.png";